import AuthProvider from "./provider/authProvider";
import Routes from "./routes";
import { usePopupKeyboard } from "./popupKeyboard.js";
import "./css/App.css";

const App = () => {
    usePopupKeyboard();
    return (
        <AuthProvider>
            <Routes />
        </AuthProvider>
    );
}

export default App;

